import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/dist/js/swiper.min';
import 'swiper/dist/css/swiper.min.css';
// import '@/assets/styles/index.scss' // global css
// import App from './App.vue';
import router from './router/index';
import Layout from './components/Layout.vue';
import { Component } from 'vue-property-decorator';
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate'
]);
Vue.use(ElementUI);
new Vue({
    el: '#app',
    router: router,
    components: { Layout: Layout },
    template: '<Layout/>',
    render: function (h) { return h(Layout); }
});
